import { Component, Input } from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
  selector: 'txp-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss'],
  standalone: true,
  imports: [NgClass],
})
export class LandingComponent {
  @Input() icon;
  @Input() title: string;
  @Input() message: string;
}
